import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import trabalhador from "../img/empresarial/trabalhador.jpg";
import saude from "../img/empresarial/saude.png";
import carteiraTrabalho from "../img/empresarial/carteira-trabalho.jpg";
import carteira from "../img/empresarial/carteira.jpg";
import bannerImg from "../img/backgroud.jpg"; // adicione a imagem desejada
import casalBranco from "../img/icon-empresarial/Casal Branco.png";
import EmpresariaBranco from "../img/icon-empresarial/Empresaria Branco.png";
import PastaLock from "../img/icon-empresarial/Pasta Lock Branco.png";
import PessoasBranco from "../img/icon-empresarial/Pessoas Branco.png";
import Img1 from "../img/empresarial/img1.png";
import Img2 from "../img/empresarial/img2.png";
import Img5 from "../img/empresarial/img5.jpg";

const Empresarial2 = () => {
  useEffect(() => {
    Aos.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
    });
    window.scrollTo(0, 0);
  }, []);

  const cards = [
    {
      title: "PROCESSO DE REINTEGRAÇÃO AO TRABALHO",
      text: "Importância do acompanhamento médico, readaptação e suporte da equipe para uma reintegração bem-sucedida.",
      img: trabalhador,
    },
    {
      title: "IMPACTO ECONÔMICO E SOCIAL DOS AFASTAMENTOS",
      text: "Direitos e impactos dos afastamentos para o empregado e a sociedade.",
      img: carteira,
    },
    {
      title: "ASPECTOS LEGAIS E PREVIDENCIÁRIOS",
      text: "Informações sobre a legislação trabalhista e previdenciária relacionadas aos afastamentos.",
      img: carteiraTrabalho,
    },
    {
      title: "POLÍTICAS DE SAÚDE E SEGURANÇA NO TRABALHO",
      text: "Medidas preventivas e políticas de saúde no ambiente laboral.",
      img: saude,
    },
  ];

  const cards2 = [
    {
      title: "Due Diligence:",
      text: " Realizamos uma análise detalhada de futuros parceiros comerciais, fusões e aquisições, garantindo que você tenha um panorama claro e preciso antes de tomar qualquer decisão estratégica.",
      img: EmpresariaBranco,
    },
    {
      title: "Verificação de Antecedentes:",
      text: "Avaliamos o histórico de funcionários, candidatos a emprego e outros indivíduos relevantes para a sua empresa, assegurando que você trabalhe com pessoas confiáveis e qualificadas.",
      img: PessoasBranco,
    },
    {
      title: "Monitoramento de Concorrentes:",
      text: "Coletamos informações estratégicas sobre seus concorrentes, ajudando você a identificar oportunidades e ameaças no mercado e a se manter sempre um passo à frente.",
      img: casalBranco,
    },
    {
      title: "Investigações Internas:",
      text: " Investigamos comportamentos suspeitos ou antiéticos dentro da sua organização, como assédio, roubos internos, e vazamentos de informações confidenciais.",
      img: PastaLock,
    },
  ];

  return (
    <>
      <style>
        {`

        
      
        `}
      </style>
      <div className=" empresarial-area">
        <div className="introducao-empresarial mt-30" data-aos="fade-left">
          <h1>
            INVESTIGAÇÃO EM <br />{" "}
            <span style={{ color: "rgb(117, 15, 15)" }}>
              CAUSAS TRABALHISTAS
            </span>{" "}
          </h1>
          <p>
            Carmem Investigações realiza análises detalhadas para identificar,
            compreender e solucionar problemas internos nas organizações,
            garantindo a integridade e a segurança empresarial. A investigação
            particular em causas trabalhistas é uma área com alta demanda, já
            que muitas empresas enfrentam fraudes e litígios relacionados a
            funcionários.
          </p>
        </div>
      </div>
      <div className="empresarial-services">
        <section
          className="empresarial-banner"
          style={{
            position: "relative",
            padding: "0",
            minHeight: "900px",
            width: "100%",
            backgroundImage: `url(${bannerImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              background: "rgba(255,0,0,0.4)", // vermelho com transparência baixa
              zIndex: 1,
            }}
          />

          <div className=" container-service">
            <div className="card-grid2 mt-100 mb-110" data-aos="fade-up">
              {cards2.map((card2, index) => (
                <div className="info-card2" key={index}>
                  <img src={card2.img} alt={card2.title} />
                  <h3>{card2.title}</h3>
                  <p>{card2.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>

      <h1 style={{ fontSize: 25, padding: 20 }}>
        {" "}
        <span style={{ color: "rgb(117, 15, 15)" }}>INVESTIGAÇÃO</span> |
        EMPRESARIAL
      </h1>
      <section className="service-section">
        <div className="text-service">
          <h3>
            {" "}
            <span>&mdash;</span> Desvio de Bens e Recursos da Empresa{" "}
          </h3>
          <p>
            Identificação de funcionários envolvidos em furtos ou desvios
            internos. Investigação de fraudes em reembolsos, vale-transporte e
            benefícios.
          </p>

          <h3>
            {" "}
            <span>&mdash;</span> Fraudes e Desvios Internos{" "}
          </h3>
          <p>
            Investigação de funcionários suspeitos de desvio de dinheiro, bens
            ou informações sigilosas. Auditoria de processos internos para
            identificar vulnerabilidades.
          </p>
        </div>
        <div className="service-image">
          <img src={Img1} alt="Due Diligence" />
        </div>
      </section>

      <section className="service-section">
        <div className="service-image">
          <img src={carteiraTrabalho} alt="Due Diligence" />
        </div>
        <div className="text-service2">
          <h3>
            {" "}
            <span>&mdash;</span> Simulação de Acidente de Trabalho{" "}
          </h3>
          <p>
            Funcionários que alegam acidentes falsos para obter indenizações.
            Coleta de provas para demonstrar que o acidente não ocorreu nas
            dependências da empresa ou no horário de trabalho.
          </p>
          <h3>
            {" "}
            <span>&mdash;</span> Acúmulo de Empregos Irregular{" "}
          </h3>
          <p>
            Funcionários afastados que estão trabalhando para outras empresas ao
            mesmo tempo. Verificação de vínculo simultâneo que prejudique a
            empresa.
          </p>
        </div>
      </section>

      <section className="service-section">
        <div className="text-service">
          <h3>
            {" "}
            <span>&mdash;</span> Identificação de Testemunhas Suspeitas{" "}
          </h3>
          <p>
            Verificação do histórico de testemunhas em processos trabalhistas.
            Investigação de testemunhas de má-fé que participam de várias ações.
          </p>

          <h3>
            {" "}
            <span>&mdash;</span> Assédio Moral e Sexual{" "}
          </h3>
          <p>
            Coleta de provas para defesa da empresa ou do funcionário em
            processos. Identificação de falsas acusações de assédio no ambiente
            de trabalho. Monitoramento e entrevistas sigilosas para detectar
            comportamento abusivo.
          </p>
        </div>
        <div className="service-image">
          <img src={Img2} alt="Due Diligence" />
        </div>
      </section>

      <section className="service-section">
        <div className="service-image">
          <img src={Img5} alt="Due Diligence" />
        </div>
        <div className="text-service2">
          <h3>
            {" "}
            <span>&mdash;</span> Concorrência Desleal e Violação de Contratos{" "}
          </h3>
          <p>
            Checagem de informações para processos de contratação. Identificação
            de empresas concorrentes utilizando práticas ilegais. Coleta de
            provas para ações judiciais de quebra de contrato ou violação de
            cláusulas de não concorrência.
          </p>
          <h3>
            {" "}
            <span>&mdash;</span> Fraudes em Afastamentos e Licenças Médicas{" "}
          </h3>
          <p>
            Funcionários que alegam doenças para se afastar, mas continuam
            trabalhando informalmente. Investigação de atestados médicos
            falsificados Monitoramento para verificar se o funcionário está
            respeitando as restrições médicas.
          </p>
        </div>
      </section>

      <div id="merox-blog-area" className="merox-blog-area mt-100 mb-110">
        <div className="empresarial-area">
          <div className="row">
            <div className="col-12">
              <div className="empresarial-desenvolvimento" data-aos="fade-up">
                <div
                  className="introducao-empresarial mt-30"
                  data-aos="fade-left"
                >
                  <h1>
                    AFASTAMENTOS DO <br />{" "}
                    <span style={{ color: "rgb(117, 15, 15)" }}>
                      TRABALHO NO BRASIL
                    </span>{" "}
                  </h1>
                </div>
                <h4
                  className="empresarial-desenvolvimeto mt-30"
                  data-aos="fade-up"
                >
                  AFASTAMENTOS POR TRANSTORNOS MENTAIS E COMPORTAMENTAIS
                </h4>
                <div
                  className="empresarial-desenvolvimento mb-50"
                  data-aos="fade-left"
                >
                  <p>
                    Nos últimos anos, houve um aumento significativo nos
                    afastamentos relacionados a transtornos mentais e
                    comportamentais. De acordo com dados do Instituto Nacional
                    do Seguro Social (INSS), em 2022, foram registrados 209.124
                    afastamentos por essas causas, um aumento em relação aos
                    200.244 casos de 2021.
                  </p>
                </div>
              </div>

              <div className="empresarial-desenvolvimento">
                <h4
                  className="empresarial-desenvolvimento mt-30"
                  data-aos="fade-up"
                >
                  AFASTAMENTOS POR ACIDENTES DE TRABALHO
                </h4>
                <div className="mb-50" data-aos="fade-left">
                  <p>
                    Em 2021, o Brasil registrou 612.920 acidentes de trabalho
                    notificados, um aumento de 37% em relação a 2020, que teve
                    446.881 casos. Embora não haja estatísticas oficiais sobre
                    afastamentos sem necessidade, é importante que empresas
                    adotem medidas preventivas para minimizar possíveis fraudes,
                    como:
                  </p>
                  <div className="empresarial-desenvolvimento2">
                    <p>
                      <span style={{ fontWeight: "bolder", color: "black" }}>
                        Implementação de Políticas Claras:
                      </span>{" "}
                      Estabelecer diretrizes transparentes sobre licenças e
                      afastamentos.
                    </p>

                    <p>
                      <span style={{ fontWeight: "bolder", color: "black" }}>
                        Monitoramento e Auditoria:
                      </span>{" "}
                      Realizar verificações regulares para identificar
                      inconsistências.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card-grid mb-110" data-aos="fade-up">
          {cards.map((card, index) => (
            <div className="info-card" key={index}>
              <img src={card.img} alt={card.title} />
              <h3>{card.title}</h3>
              <p>{card.text}</p>
            </div>
          ))}
        </div>

        <div className="empresarial-area">
          <div className="row">
            <div className="col-12"></div>
          </div>
        </div>

        <div className="empresarial-area">
          <div className="row">
            <div className="col-12"></div>
          </div>
        </div>

        <div className="empresarial-area">
          <div className="row">
            <div className="col-12">
              <div className="section-title" data-aos="fade-up">
                <div
                  className="introducao-empresarial mt-30"
                  data-aos="fade-left"
                >
                  <h1>
                    POR QUE ESCOLHER
                    <br />{" "}
                    <span style={{ color: "rgb(117, 15, 15)" }}>
                      A CARMEM INVETIGAÇÕES?
                    </span>{" "}
                  </h1>
                </div>
                <ul className="empresarial-list">
                  <li className="mt-50 mb-50" data-aos="fade-up-left">
                    <i className="fa fa-check"></i>
                    <span className="empresarial-bold">
                      Discrição e Confidencialidade:
                    </span>{" "}
                    Entendemos a importância da confidencialidade em nossas
                    investigações. Operamos com o mais alto nível de discrição
                    para proteger a reputação e os interesses da sua empresa.
                  </li>
                  <li className="mt-50 mb-50" data-aos="fade-up-right">
                    <i className="fa fa-check"></i>
                    <span className="empresarial-bold">
                      Expertise e Experiência:
                    </span>{" "}
                    Nossa equipe é composta por profissionais altamente
                    qualificados com vasta experiência em investigações
                    empresariais, utilizando técnicas modernas e tecnologias
                    avançadas.
                  </li>
                  <li className="mt-50 mb-50" data-aos="fade-up-left">
                    <i className="fa fa-check"></i>
                    <span className="empresarial-bold">
                      Resultados Confiáveis:
                    </span>{" "}
                    Fornecemos relatórios detalhados e precisos, equipando você
                    com todas as informações necessárias para tomar decisões
                    informadas e proteger seus interesses corporativos.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="empresarial-area">
          <div className="row">
            <div className="col-12">
              <div className="empresarial-effect-phrase" data-aos="fade-down">
                <p>
                  <span>&mdash;</span>
                  Confie na nossa experiência para resguardar o seu negócio
                  contra riscos e ameaças. Entre em contato conosco hoje e
                  descubra como nossas soluções em investigação empresarial
                  podem beneficiar a sua empresa.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Empresarial2;
